(function () {
  'use strict';

  var CFG = window.KCAppointmentConfig;
  if (!CFG) return;

  var LONG_DAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

  function BookingCalendar(el) {
    this.el = el;
    this.grid = el.querySelector('.kc-cal__grid');
    this.monthLabel = el.querySelector('.kc-cal__month-label');
    this.prevBtn = el.querySelector('.kc-cal__nav-prev');
    this.nextBtn = el.querySelector('.kc-cal__nav-next');
    this.slotsContainer = el.querySelector('.kc-cal__slots');
    this.dayTitle = el.querySelector('.kc-cal__day-title');
    this.summaryEl = el.querySelector('.kc-cal__summary');
    this.summaryDate = el.querySelector('.kc-cal__summary-date');
    this.summaryTime = el.querySelector('.kc-cal__summary-time');
    this.ctaBtn = el.querySelector('.kc-cal__cta');
    this.retryBtn = el.querySelector('.kc-cal__retry-btn');

    // Right-column panels
    this.panelEmpty = el.querySelector('.kc-cal__slots-empty');
    this.panelLoading = el.querySelector('.kc-cal__slots-loading');
    this.panelError = el.querySelector('.kc-cal__slots-error');
    this.panelNone = el.querySelector('.kc-cal__slots-none');
    this.panelList = el.querySelector('.kc-cal__slots-list');

    // Preload elements
    this.preloadEl = el.querySelector('.kc-cal__preload');
    this.preloadErrorEl = el.querySelector('.kc-cal__preload-error');
    this.preloadRetryBtn = el.querySelector('.kc-cal__preload-retry-btn');

    // Reservation state
    this.timerEl = el.querySelector('.kc-cal__timer');
    this.timerCountdown = el.querySelector('.kc-cal__timer-countdown');
    this.conflictEl = el.querySelector('.kc-cal__conflict');
    this.expiredEl = el.querySelector('.kc-cal__expired');

    this.allSlots = [];
    this.slotsByDate = {};
    this.selectedDay = null;
    this.selectedSlot = null;
    this.sessionId = crypto.randomUUID();
    this.bookingId = null;
    this.reservationExpiry = null;
    this.countdownInterval = null;
    this.reserved = false;
    this.initialLoad = true;

    var now = new Date();
    this.viewYear = now.getFullYear();
    this.viewMonth = now.getMonth();
    this.today = this._dateKey(now);

    this._bindEvents();
    this._fetchAvailability();
  }

  // ── Data ─────────────────────────────────────────────
  BookingCalendar.prototype._fetchAvailability = function () {
    if (!this.initialLoad) this._showPanel('loading');
    var self = this;
    fetch(CFG.API_BASE + '/availability?weeks=' + CFG.BOOKING_WINDOW_WEEKS)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var raw = data.slots || [];
        self.allSlots = raw.map(function (s) {
          return typeof s === 'string' ? s : s.slot_id;
        });
        self._buildSlotIndex();
        self._renderMonth();
        self._showPanel('empty');
        if (self.initialLoad) {
          self.initialLoad = false;
          self._transitionToReady();
        }
      })
      .catch(function () {
        if (self.initialLoad) {
          self.initialLoad = false;
          self._showPreloadError();
        } else {
          self._showPanel('error');
        }
      });
  };

  // ── Preload Transitions ─────────────────────────────
  BookingCalendar.prototype._transitionToReady = function () {
    var self = this;
    this.preloadEl.classList.add('kc-cal__preload--hidden');

    this.preloadEl.addEventListener('transitionend', function handler() {
      self.preloadEl.removeEventListener('transitionend', handler);
      self.preloadEl.style.display = 'none';
      self.el.classList.remove('kc-cal--preloading');
      self.el.classList.add('kc-cal--ready');
    });
  };

  BookingCalendar.prototype._showPreloadError = function () {
    this.preloadEl.style.display = 'none';
    this.preloadErrorEl.style.display = '';
  };

  BookingCalendar.prototype._buildSlotIndex = function () {
    this.slotsByDate = {};
    for (var i = 0; i < this.allSlots.length; i++) {
      var iso = this.allSlots[i];
      var key = iso.substring(0, 10); // YYYY-MM-DD
      if (!this.slotsByDate[key]) this.slotsByDate[key] = [];
      this.slotsByDate[key].push(iso);
    }
  };

  // ── Calendar Rendering ───────────────────────────────
  BookingCalendar.prototype._renderMonth = function () {
    var year = this.viewYear;
    var month = this.viewMonth;

    this.monthLabel.textContent = CFG.MONTH_NAMES[month] + ' ' + year;

    // First day of month (shift to Monday=0)
    var firstDay = new Date(year, month, 1).getDay();
    var startOffset = (firstDay + 6) % 7; // Monday-based offset

    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var html = '';

    // Empty cells before first day
    for (var e = 0; e < startOffset; e++) {
      html += '<span class="kc-cal__day kc-cal__day--other-month"></span>';
    }

    for (var d = 1; d <= daysInMonth; d++) {
      var dateKey = year + '-' + this._pad(month + 1) + '-' + this._pad(d);
      var isPast = dateKey < this.today;
      var isToday = dateKey === this.today;
      var hasSlots = !!this.slotsByDate[dateKey];
      var isSelected = dateKey === this.selectedDay;

      var cls = 'kc-cal__day';
      if (isPast) cls += ' kc-cal__day--past';
      if (isToday) cls += ' kc-cal__day--today';
      if (hasSlots && !isPast) cls += ' kc-cal__day--available';
      if (isSelected) cls += ' kc-cal__day--selected';

      if (hasSlots && !isPast) {
        html += '<button type="button" class="' + cls + '" data-date="' + dateKey + '">' + d + '</button>';
      } else {
        html += '<span class="' + cls + '">' + d + '</span>';
      }
    }

    this.grid.innerHTML = html;
    this._updateNavButtons();
  };

  BookingCalendar.prototype._updateNavButtons = function () {
    var now = new Date();
    var minYear = now.getFullYear();
    var minMonth = now.getMonth();
    this.prevBtn.disabled = (this.viewYear === minYear && this.viewMonth <= minMonth);

    var maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + CFG.BOOKING_WINDOW_WEEKS * 7);
    this.nextBtn.disabled = (this.viewYear > maxDate.getFullYear() ||
      (this.viewYear === maxDate.getFullYear() && this.viewMonth >= maxDate.getMonth()));
  };

  // ── Slot Rendering ───────────────────────────────────
  BookingCalendar.prototype._showSlotsForDay = function (dateKey) {
    this.selectedDay = dateKey;
    this.selectedSlot = null;
    this._renderMonth();

    var slots = this.slotsByDate[dateKey];
    if (!slots || slots.length === 0) {
      this._showPanel('none');
      return;
    }

    var d = new Date(dateKey + 'T00:00:00');
    this.dayTitle.textContent = LONG_DAYS[d.getDay()] + ', ' + d.getDate() + '. ' + CFG.MONTH_NAMES[d.getMonth()];

    var html = '';
    for (var i = 0; i < slots.length; i++) {
      var iso = slots[i];
      var time = this._formatTime(iso);
      html += '<button type="button" class="kc-cal__slot" role="option" data-slot-id="' +
        this._escapeAttr(iso) + '">' + time + '</button>';
    }
    this.slotsContainer.innerHTML = html;

    this._showPanel('list');
    this.summaryEl.style.display = 'none';
  };

  // ── Panel Visibility ─────────────────────────────────
  BookingCalendar.prototype._showPanel = function (name) {
    this.panelEmpty.style.display = name === 'empty' ? '' : 'none';
    this.panelLoading.style.display = name === 'loading' ? '' : 'none';
    this.panelError.style.display = name === 'error' ? '' : 'none';
    this.panelNone.style.display = name === 'none' ? '' : 'none';
    this.panelList.style.display = name === 'list' ? '' : 'none';
  };

  // ── Slot Selection ───────────────────────────────────
  BookingCalendar.prototype._selectSlot = function (slotId) {
    if (this.reserved) return;

    this.selectedSlot = slotId;
    this._hideMessages();

    var btns = this.slotsContainer.querySelectorAll('.kc-cal__slot');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].dataset.slotId === slotId) {
        btns[i].classList.add('kc-cal__slot--selected');
        btns[i].setAttribute('aria-selected', 'true');
      } else {
        btns[i].classList.remove('kc-cal__slot--selected');
        btns[i].removeAttribute('aria-selected');
      }
    }

    var d = new Date(slotId);
    var dayNum = d.getDate();
    var monthName = CFG.MONTH_NAMES[d.getMonth()];
    var year = d.getFullYear();
    var dayName = LONG_DAYS[d.getDay()];

    var startH = this._pad(d.getHours());
    var startM = this._pad(d.getMinutes());
    var endDate = new Date(d.getTime() + CFG.SLOT_DURATION * 60000);
    var endH = this._pad(endDate.getHours());
    var endM = this._pad(endDate.getMinutes());

    this.summaryDate.textContent = dayName + ', ' + dayNum + '. ' + monthName + ' ' + year;
    this.summaryTime.textContent = startH + ':' + startM + ' – ' + endH + ':' + endM + ' Uhr (Berlin)';
    this.summaryEl.style.display = '';

    this._reserveSlot(slotId);
  };

  // ── Reservation ────────────────────────────────────────
  BookingCalendar.prototype._reserveSlot = function (slotId) {
    var self = this;
    this.ctaBtn.disabled = true;
    this.ctaBtn.textContent = '…';

    fetch(CFG.API_BASE + '/booking/reserve', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slot_id: slotId, session_id: this.sessionId }),
    })
      .then(function (res) {
        if (res.status === 409) {
          self._handleConflict(slotId);
          return null;
        }
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data) return;
        self.bookingId = data.booking_id;
        self.reserved = true;
        self.reservationExpiry = Date.now() + CFG.TEMP_BLOCK_TTL * 1000;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { appointment_slot: slotId } }),
        });
      })
      .then(function (res) {
        if (!res) return;
        self.ctaBtn.disabled = false;
        self.ctaBtn.textContent = self.el.dataset.ctaLabel;
        self._showTimer();
        self._startCountdown();
      })
      .catch(function () {
        self.ctaBtn.disabled = true;
        self.ctaBtn.textContent = self.el.dataset.ctaLabel;
        self.selectedSlot = null;
        self.reserved = false;
        self._deselectAllSlots();
        self._showPanel('error');
      });
  };

  BookingCalendar.prototype._handleConflict = function (slotId) {
    this.selectedSlot = null;
    this.reserved = false;
    this._deselectAllSlots();
    this.ctaBtn.disabled = true;
    this.ctaBtn.textContent = this.el.dataset.ctaLabel;

    var btn = this.slotsContainer.querySelector('[data-slot-id="' + CSS.escape(slotId) + '"]');
    if (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('tabindex', '-1');
      btn.classList.add('kc-cal__slot--unavailable');
    }

    this.conflictEl.style.display = '';
    var self = this;
    this._fetchAvailability();
  };

  BookingCalendar.prototype._deselectAllSlots = function () {
    var btns = this.slotsContainer.querySelectorAll('.kc-cal__slot--selected');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.remove('kc-cal__slot--selected');
      btns[i].removeAttribute('aria-selected');
    }
  };

  BookingCalendar.prototype._hideMessages = function () {
    this.conflictEl.style.display = 'none';
    this.expiredEl.style.display = 'none';
    if (this.timerEl) this.timerEl.style.display = 'none';
  };

  BookingCalendar.prototype._showTimer = function () {
    if (this.timerEl) this.timerEl.style.display = '';
  };

  // ── Countdown Timer ────────────────────────────────────
  BookingCalendar.prototype._startCountdown = function () {
    this._stopCountdown();
    this._tickCountdown();
    this.countdownInterval = setInterval(this._tickCountdown.bind(this), 1000);
  };

  BookingCalendar.prototype._stopCountdown = function () {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  };

  BookingCalendar.prototype._tickCountdown = function () {
    var remaining = Math.max(0, Math.floor((this.reservationExpiry - Date.now()) / 1000));
    if (remaining <= 0) {
      this._handleExpiry();
      return;
    }
    var min = Math.floor(remaining / 60).toString().padStart(2, '0');
    var sec = (remaining % 60).toString().padStart(2, '0');
    this.timerCountdown.textContent = min + ':' + sec;
  };

  BookingCalendar.prototype._handleExpiry = function () {
    this._stopCountdown();
    this.selectedSlot = null;
    this.bookingId = null;
    this.reserved = false;
    this.ctaBtn.disabled = true;
    this._hideMessages();
    this.expiredEl.style.display = '';
    if (this.timerEl) this.timerEl.style.display = 'none';
    this._deselectAllSlots();

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { appointment_slot: '' } }),
    }).catch(function () {});

    var self = this;
    setTimeout(function () {
      self.expiredEl.style.display = 'none';
      self._fetchAvailability();
    }, 3000);
  };

  // ── Cart + Checkout ──────────────────────────────────
  BookingCalendar.prototype._goToCheckout = function () {
    if (!this.selectedSlot || !this.reserved) return;
    this.ctaBtn.disabled = true;
    this.ctaBtn.textContent = '…';
    window.location.href = '/checkout';
  };

  // ── Events ───────────────────────────────────────────
  BookingCalendar.prototype._bindEvents = function () {
    var self = this;

    this.grid.addEventListener('click', function (e) {
      var btn = e.target.closest('.kc-cal__day--available');
      if (!btn || !btn.dataset.date) return;
      if (self.reserved) return;
      self._showSlotsForDay(btn.dataset.date);
    });

    this.slotsContainer.addEventListener('click', function (e) {
      var btn = e.target.closest('.kc-cal__slot');
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      if (self.reserved) return;
      self._selectSlot(btn.dataset.slotId);
    });

    this.ctaBtn.addEventListener('click', function () {
      self._goToCheckout();
    });

    this.prevBtn.addEventListener('click', function () {
      self.viewMonth--;
      if (self.viewMonth < 0) { self.viewMonth = 11; self.viewYear--; }
      self._renderMonth();
    });

    this.nextBtn.addEventListener('click', function () {
      self.viewMonth++;
      if (self.viewMonth > 11) { self.viewMonth = 0; self.viewYear++; }
      self._renderMonth();
    });

    if (this.retryBtn) {
      this.retryBtn.addEventListener('click', function () {
        self._fetchAvailability();
      });
    }

    if (this.preloadRetryBtn) {
      this.preloadRetryBtn.addEventListener('click', function () {
        window.location.reload();
      });
    }
  };

  // ── Helpers ──────────────────────────────────────────
  BookingCalendar.prototype._dateKey = function (d) {
    return d.getFullYear() + '-' + this._pad(d.getMonth() + 1) + '-' + this._pad(d.getDate());
  };

  BookingCalendar.prototype._pad = function (n) {
    return String(n).padStart(2, '0');
  };

  BookingCalendar.prototype._formatTime = function (iso) {
    var d = new Date(iso);
    return this._pad(d.getHours()) + ':' + this._pad(d.getMinutes());
  };

  BookingCalendar.prototype._escapeAttr = function (s) {
    return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  };

  // ── Init ─────────────────────────────────────────────
  function init() {
    document.querySelectorAll('.kc-cal').forEach(function (el) {
      new BookingCalendar(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
